const marketplace = {
  title: "Tienda de complementos",
  subtitle: "Potencia tu negocio con herramientas y alianzas",
  sections: {
    myTools: "Mis herramientas",
    bestSellers: "Más vendidos",
    partners: "Alianzas",
  },
  card: {
    installed: "Activo",
  },
  detail: {
    back: "Volver",
    loading: "Cargando complemento...",
    loadError: "No se pudo cargar el complemento",
    reviews: "Opiniones",
    availableInApp: "Esta herramienta está disponible desde la app de Domun.",
    acquired: "Adquirido",
    free: "Gratis",
    open: "Abrir",
    getFree: "Obtener gratis",
    acquire: "Adquirir",
    freeSuccess: "¡Complemento activado correctamente!",
    acquireError: "No se pudo adquirir el complemento",
    openAlliance: "Ir a la alianza",
  },
};

export default marketplace;
